import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ResultsScreen from "@/components/valuation/ResultsScreen";

const ResultsPage = () => {
    const navigate = useNavigate();
    const [valuationResult, setValuationResult] = useState(null);
    const [leadInfo, setLeadInfo] = useState(null);

    useEffect(() => {
        // Get results from sessionStorage
        const storedResult = sessionStorage.getItem("valuationResult");
        const storedLead = sessionStorage.getItem("leadInfo");

        if (storedResult && storedLead) {
            const result = JSON.parse(storedResult);
            const lead = JSON.parse(storedLead);
            
            setValuationResult(result);
            setLeadInfo(lead);
            
            // Push GTM dataLayer event for valuation completion
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: "valuation_complete",
                valuation_low: result.valuation_low,
                valuation_high: result.valuation_high,
                benchmark_score: result.benchmark_score,
                lead_name: `${lead.first_name} ${lead.last_name}`,
                lead_email: lead.email,
                lead_state: lead.state,
                lead_planning_to_sell: lead.planning_to_sell
            });
        } else {
            // No results found, redirect to home
            navigate("/");
        }
    }, [navigate]);

    const handleRestart = () => {
        sessionStorage.removeItem("valuationResult");
        sessionStorage.removeItem("leadInfo");
        navigate("/");
    };

    if (!valuationResult || !leadInfo) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <div className="text-center">
                    <p className="text-gray-500">Loading results...</p>
                </div>
            </div>
        );
    }

    return (
        <ResultsScreen 
            result={valuationResult} 
            leadInfo={leadInfo}
            onRestart={handleRestart}
        />
    );
};

export default ResultsPage;
